import React from 'react'
import { NavLink } from 'react-router-dom'
import MDKlogo from '../assets/images/mdk-logo.svg'

const Navbar = () => {
  return (
    <nav className='__navbar navbar navbar-default navbar-static-top border-bottom pb-3'>
        <div className='container-fluid'>
            <a href='http://www.modstandsdygtig.dk' target="_blank" rel="noreferrer" className='me-auto'>
              <img src={MDKlogo} alt="Modstandsdygtig.dk-logo" />
            </a>
            <div className='gap-3 d-flex __nav-items'>
              <NavLink className="nav-item" to="/" end>HJEM</NavLink>
              <NavLink className="nav-item" to="/start-test" end>Test</NavLink>
              <NavLink className="nav-item" to="/scenarios" end>Scenarier</NavLink>              
            </div>

        </div>
    </nav>
  )
}

export default Navbar